<template>
  <div class="text-grey">
    <p class="uppercase font-bold text-base">{{ t(`legends.${type}`) }}</p>
    <div
      class="flex flex-col lg:flex-row lg:flex-wrap 2xl:flex-col gap-2.5 lg:gap-x-6 mt-2.5 transition-[margin_gap]"
    >
      <div
        v-for="i in type === 'personas' ? 7 : 10"
        :class="[
          'flex gap-3 text-left lg:w-[calc(50%-0.75rem)] 2xl:w-full transition-[width]',
          {
            'cursor-pointer items-start': type === 'principles',
            'items-center': type === 'personas',
            'gap-2!': type === 'principles',
          },
        ]"
      >
        <span
          v-if="type === 'personas'"
          class="bg-black w-10 aspect-square rounded-full flex items-center justify-center shrink-0"
        >
          <IconSprite
            :id="`personas_${i}` as Icon"
            class="text-[22px] text-white"
            role="presentation"
          />
        </span>
        <span v-if="type === 'principles'" class="min-w-5">{{ `${i}.` }}</span>
        <button
          :id="`${type}.${i}`"
          v-if="type === 'principles'"
          :class="[
            'text-left group cursor-pointer',
            {
              underline: tooltip?.id === `${type}.${i}`,
            },
          ]"
          @click.stop="
            updateToolTip($event, `${type}.${i}`, false, true, `${type}.${i}`)
          "
          @touchstart.stop="
            updateToolTip($event, `${type}.${i}`, false, true, `${type}.${i}`)
          "
          @mouseenter.stop="updateToolTip($event, `${type}.${i}`, false, false)"
          @mouseleave.stop="removeToolTip"
        >
          <span>{{ t(`${type}.${i}.title`) }}</span>
          <IconSprite
            id="chevron"
            role="presentation"
            class="text-[10px] ml-1.5 transition-[margin] group-hover:ml-2"
          />
        </button>
        <span v-if="type === 'personas'">
          {{ `${i}. ${t(`${type}.${i}.title`)}` }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import IconSprite from '@/components/small/IconSprite.vue'
import { useToolTipControls } from '@/composables/useToolTipControls.ts'
import { toRef } from 'vue'

const { t } = useI18n()

const { tooltip, type } = defineProps<{
  tooltip: ToolTip | null
  type: Category
}>()

const emit = defineEmits(['remove:tooltip', 'update:tooltip'])

const { updateToolTip, removeToolTip } = useToolTipControls(
  emit,
  toRef(() => tooltip)
)
</script>
